import React from "react"
import Grid from "../../../../grid"
import { P } from "../../../../typography"
import { Ul, Li } from "./styles"

const Checkbox = ({ label, answer }) => {
  const values = Array.isArray(answer)
    ? answer
    : answer
        .toString()
        .split(",")
        .filter((n) => n)

  return (
    <Grid gap="4px">
      {label && label.length > 0 && (
        <P variant="content" marginless profileLabel>
          {label}
        </P>
      )}
      {values && values.length > 0 ? (
        <Ul profileData>
          {values.map((value) => (
            <Li profileData> {value} </Li>
          ))}
        </Ul>
      ) : (
        <P variant="content" marginless profileData>
          -
        </P>
      )}
    </Grid>
  )
}

export default Checkbox
